RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TablePart = Marionette.CollectionView.extend({
        limit: Infinity,
        reorderOnSort: true,
        childView: views.TableRow,

        childViewOptions: function () {

            const me = this;
            return {
                isHeader: me.getOption('isHeader')
            };
        },

        initialize: function (options) {

            const me = this;
            const opts = options || {};
            me.collection = new Backbone.Collection(opts.rows);
        },

        filter: function (child, index) {

            const me = this;
            return (index < me.getOption('limit'));
        },

        updateSortedColumns: function (config) {

            const me = this;
            const sortedProperty = _.result(config, 'property');
            const className = _.result(config, 'className');
            const ascendingClassName = _.result(config, 'ascendingClassName');
            const descendingClassName = _.result(config, 'descendingClassName');
            const sortOrder = _.result(config, 'sortOrder');

            me.children.each(function (row) {

                row.children.each(function (column) {

                    const property = (column.model.get('sortKey') || column.model.get('property'));

                    if (property !== sortedProperty) {

                        column.$el.removeClass(className)
                            .removeClass(descendingClassName)
                            .removeClass(ascendingClassName);
                    } else {

                        column.$el.addClass(className);

                        // if we have a sortOrder, use it. Otherwise just continue to toggle.
                        if (_.isFinite(sortOrder)) {
                            column.$el
                                .removeClass(descendingClassName)
                                .removeClass(ascendingClassName)
                                .addClass(sortOrder > 0 ? ascendingClassName : descendingClassName);
                        } else {

                            if (column.$el.hasClass(ascendingClassName)) {

                                column.$el.removeClass(ascendingClassName)
                                    .addClass(descendingClassName);
                            } else {

                                column.$el.removeClass(descendingClassName)
                                    .addClass(ascendingClassName);
                            }
                        }

                    }
                });
            });
        }
    });

});
